// import { createStore, combineReducers } from 'redux';
// import { reducer as reduxFormReducer} from 'redux-form';

// import globalVar from './reducers/globalVar';

// const reducer = combineReducers({
//     globalVar,
//     form: reduxFormReducer,

// });
// const store = createStore(reducer);

// export default store;



import { configureStore, combineReducers } from '@reduxjs/toolkit';
import globalVarReducer from './reducers/globalVar'; 
import permissionsReducer from './reducers/permissions'; 

const rootReducer = combineReducers({
    globalVar: globalVarReducer,
    permissions: permissionsReducer
});

const store = configureStore({
    reducer: rootReducer
});

export default store;

